/**
 * 區塊的「載入失敗 / 空資料」狀態，全站共用。
 *   - 有 error → 顯示「暫時無法載入」+ 重新載入鈕（onRetry 存在時）
 *   - 無 error（回空資料）→ 顯示 emptyText（預設「目前沒有內容。」）
 *
 * 樣式 .section-state / .section-state-retry 定義在 styles/global.css。
 */
function SectionState({ error, onRetry, emptyText = '目前沒有內容。' }) {
  if (error) {
    return (
      <div className="section-state">
        <p>暫時無法載入，請稍後再試。</p>
        {onRetry && <button className="section-state-retry" onClick={onRetry}>重新載入</button>}
      </div>
    );
  }
  return (
    <div className="section-state">
      <p>{emptyText}</p>
    </div>
  );
}

export default SectionState;
